import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

//******************************************************************************
//  NPM (Packages) External
//******************************************************************************
import { SDKLoadingModule } from 'sdk-loading';

//******************************************************************************
//  Services
//******************************************************************************
import { AppSettingsService } from '../../services/appsettings.service';
import { GraphService } from '../../services/graph.service';

//******************************************************************************
//  Pages
//******************************************************************************
import { AuthComponent } from '../../pages/auth/auth.component';
import { NotFoundComponent } from '../../pages/notfound/notfound.component';

//******************************************************************************
//  Core Components
//******************************************************************************
import { HeaderComponent } from '../../components/layout/header/header.component';
import { NavComponent } from '../../components/layout/nav/nav.component';
import { FooterComponent } from '../../components/layout/footer/footer.component';
import { AccessComponent } from '../../components/access/access.component';
import { AlertComponent } from '../../components/alert/alert.component';
import { ErrorComponent } from '../../components/error/error.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SDKLoadingModule,
    ],
    declarations: [
        HeaderComponent,
        NavComponent,
        FooterComponent,
        AccessComponent,
        AlertComponent,
        ErrorComponent,
        AuthComponent,
        NotFoundComponent,
    ],
    exports: [
        CommonModule,
        FormsModule,
        HeaderComponent,
        NavComponent,
        FooterComponent,
        AccessComponent,
        AlertComponent,
        ErrorComponent,
        AuthComponent,
        NotFoundComponent,
    ],
    providers: [
        AppSettingsService,
        GraphService,
    ],
})

export class CoreImports { }
